import { ASSET_BASE_URL } from "../../config/env";

const PlanCard = ({ title, type, data, expiry, operator, onRenew, onChange, onDevices, onStelfiberDevices, onDelete, loading, 
  cooldownActive, remainingTime, disableActions, checking }) => {
  // Still loading the customer's plans — don't claim "No plan selected"
  // for a customer who actually has one.
  if (checking) {
    return (
      <div className="plan-card12 loading-card12">
        <div className="spinner12"></div>
        <p>Loading {title} plan…</p>
      </div>
    );
  }

  if (!data) {
    return (
      <div className="plan-card empty">
        <h4>{title}</h4> 
        <p>No plan selected</p>
        <button onClick={onChange}>Select Plan</button>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="plan-card12 loading-card12">
        <div className="spinner12"></div>
        <p>Processing...</p>
      </div>
    );
  }

  const isActivePlan = (expiry) => {
    if (!expiry) return false;

    const today = new Date();
    const exp = new Date(expiry);

    // remove time
    today.setHours(0,0,0,0);
    exp.setHours(0,0,0,0);

    return exp >= today;
  };

  const isActive = isActivePlan(expiry);

  return (
    <div
  className={`plan-card ${type} ${
    isActive ? "active-plan" : "expired-plan"
  }`}
>
      
      {/* HEADER */}
      <div className="plan-header">
        <h3 className="plan-title">{data.planName}</h3>
        <span className="plan-price">
          ₹ {operator ? data.planPrice + operator.packPrice : data.planPrice}
        </span>
      </div>

      {/* EXPIRY (placeholder for now) */}
      <div className="plan-expiry">
        <p className="cust-expiry">Expiry Date:  {expiry? expiry : "--"}</p> {/* later replace with API */}
      </div>

      {/* OTT APPS */}
      <div className="ott-grid-cust">
        {data.ott?.map((app) => {
            const lowerOtt = app.toLowerCase();

            return (
            <div key={app} className="ott-item-cust">
                <img
                src={`${ASSET_BASE_URL}/${lowerOtt}.png`}
                alt={app}
                onError={(e) => {
                    e.target.src = `${ASSET_BASE_URL}/default.png`;
                }}
                />
                <p>{app}</p>
            </div>
            );
        })}
      </div>

      {/* ACTION */}
      {(!disableActions && type !== "playboxtv") && (
        <div className="plan-actions">
          <button
            onClick={onRenew}
            disabled={
              loading ||
              cooldownActive ||
              (isActive && !cooldownActive && (type === "playboxtv" ||
                type === "pioneeriptv" || type === "antiptv" || type === "etvwin" )) // advance renewal not available yet for these (Watcho has it)
            }
          >
            {cooldownActive
              ? `Recharge ${remainingTime}`
              : (type === "playboxtv" || type === "pioneeriptv" ||
                type === "antiptv" || type === "etvwin") && isActive
              ? "Advance Renewal (Coming Soon)"
              : isActive
              ? "Advance Renewal"
              : "Recharge"}
          </button>
          <button
            onClick={onChange}
            disabled={isActive}
          >
            Change Plan
          </button>
          {type === "vrplay" && (
            <>
              <button onClick={onDevices}>Devices</button>
              <button onClick={onStelfiberDevices}>Stelfiber Devices</button>
            </>
          )}
          {onDelete && (
              <button className="btn-delete1" onClick={onDelete} disabled={isActive}>
                  Remove
              </button>
          )}
        </div>
      )}

    </div>
  );
};

export default PlanCard;